module.exports = __webpack_public_path__ + "img/photo-projects-journal.574f30a1.jpg";